module.exports = __webpack_public_path__ + "media/icons/cuk_mail@3x-4c2afae0.svg";